import { FC, useEffect } from "react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import style from "./LimitIsReachModal.module.scss";
import usePlanDetails from "@/hooks/common/usePlanDetails";
import { When } from "@/components/common/When";
import { Button } from "@/components/common/Button";
import { openChatPopup } from "@/helper/helper";
import { TfiClose } from "react-icons/tfi";
import { useIsExpired } from "@/states/user.state";
import IFThen from "@/components/common/IFThen";
import cn from "classnames";
type LimitIsReachModalType = {
  plan_uuid?: string;
};
const LimitIsReachModal: FC<LimitIsReachModalType> = ({
  plan_uuid
}) => {
  const t = useTranslations("AlertsDashboard.LimitIsReachModal");
  const {
    data,
    mutatePlanDetails,
    isLoading
  } = usePlanDetails();
  const {
    setParams
  } = useIsExpired();
  const handleRequest = () => {
    if (!isLoading) {
      if (plan_uuid) {
        mutatePlanDetails(plan_uuid);
      } else {
        mutatePlanDetails("freeTrial");
      }
    }
  };
  useEffect(() => {
    handleRequest();
  }, [plan_uuid]);
  function onReach() {
    setParams({
      isReach: false
    });
  }
  function onOpenChatPopup() {
    openChatPopup();
    onReach();
  }
  return <When condition={!isLoading} data-sentry-element="When" data-sentry-component="LimitIsReachModal" data-sentry-source-file="LimitIsReachModal.tsx">
      <div className={cn(style.wrapper, "limit_popup")} id="limit-is-reach-modal-wrapper">
        <div className={style.backdrop} onClick={onReach}></div>
        <div className={style.box}>
          <button className={style.close_btn} onClick={onReach}>
            <TfiClose color={"#A1A1A1"} size={14} data-sentry-element="TfiClose" data-sentry-source-file="LimitIsReachModal.tsx" />
          </button>
          <div className={style.imageBox}>
            <Image src={"/dashboard-assets/limited.svg"} alt="Limited icon" height={208} width={218} data-sentry-element="Image" data-sentry-source-file="LimitIsReachModal.tsx" />
          </div>
          <h3>{t("title")}</h3>
          <p className={style.des}>
            <When condition={!!data?.data.message} data-sentry-element="When" data-sentry-source-file="LimitIsReachModal.tsx">
              <span dangerouslySetInnerHTML={{
              __html: data?.data.message + "."
            }} />
            </When>
          </p>
          <div className={style.planDetailsBox}>
            <div className={style.row}>
              <span className={style.left}>{data?.data.limits.dynamic_qr_codes}</span>
              <span className={style.right}>
                {t("dynamicQRCodes")}
                <div className={style.tooltip}>
                  <p>{t("totalEditableQRCodes")}</p>
                </div>
              </span>
            </div>
            <div className={style.row}>
              <span className={style.left}>
                {" "}
                {data?.data.limits.yearly_scans ?? t("unlimitedScans")}
              </span>
              <span className={style.right}>
                {t("scans")}
                <div className={style.tooltip}>
                  <p>{t("scanTracking")}</p>
                </div>
              </span>
            </div>
            <When condition={!!data?.data.limits.monthly_api_requests} data-sentry-element="When" data-sentry-source-file="LimitIsReachModal.tsx">
              <div className={style.row}>
                <span className={style.left}>{data?.data.limits.monthly_api_requests}</span>
                <span className={style.right}>
                  {t("apiRequests")}
                  <div className={style.tooltip}>
                    <p>{t("monthlyApiLimit")}</p>
                  </div>
                </span>
              </div>
            </When>
            <When condition={!!data?.data.limits.bulk_create} data-sentry-element="When" data-sentry-source-file="LimitIsReachModal.tsx">
              <div className={style.row}>
                <span className={style.left}>{data?.data.limits.bulk_create}</span>
                <span className={style.right}>
                  {t("bulkCreation")}
                  <div className={style.tooltip}>
                    <p>{t("bulkCreationDescription")}</p>
                  </div>
                </span>
              </div>
            </When>
            <div className={style.row}>
              <span className={style.left}>{data?.data.limits.total_managers}</span>
              <span className={style.right}>
                {t("users")}
                <div className={style.tooltip}>
                  <p>{t("userLimit")}</p>
                </div>
              </span>
            </div>
          </div>
          <IFThen condition={data?.data.payload.limit_popup_btn_key === "contact"} Then={<Button className={style.redirect_btn} variant="primary" title={t("contactUs")} onClick={onOpenChatPopup} id="limit-is-reach-modal-contact-us-btn" />} Else={<IFThen condition={data?.data.payload.limit_popup_btn_key === "plans"} Then={<Link className={style.link_btn} href={"/dashboard/pricing"}>
                    <Button title={t("seePlansPricing")} variant="primary" className={style.redirect_btn} id="limit-is-reach-modal-see-plans-btn" />
                  </Link>} Else={<Link className={style.link_btn} href={"/dashboard/pricing"}>
                    <Button title={t("upgrade")} variant="primary" className={style.redirect_btn} id="limit-is-reach-modal-upgrade-btn" />
                  </Link>} />} data-sentry-element="IFThen" data-sentry-source-file="LimitIsReachModal.tsx" />
        </div>
      </div>
    </When>;
};
export default LimitIsReachModal;